export default __webpack_public_path__ + "static/media/ethereum-nav.74429334.png";